<template>
  <div class="books-preview" :class="[$$FormData.show_type]">
    <div v-if="$$FormData.title" class="books-title">{{ $$FormData.title }}</div>
    <div v-if="$$FormData.subtitle" class="books-subtitle">{{ $$FormData.subtitle }}</div>
    <div class="books-list">
      <div v-for="item in $$FormData.books" :key="item.id" class="book-item">
        <div class="book-item-inner">
          <div class="cover-view">
            <img :src="item.cover_image" class="book-cover" alt=""/>
            <div v-if="item.type === 'AUDIOBOOK'" class="icon-listen-book"/>
          </div>
          <div class="book-info">
            <div class="book-name">
              <div class="book-name-text ellipsis">{{ item.name }}</div>
              <div v-if="item.author" class="author-name">{{ item.author }} <span class="dot">著</span></div>
            </div>
            <div
              v-if="!$$FormData.show_type || $$FormData.show_type === 'default'"
              class="book-content ellipsis"
            >{{ item.introduction }}</div>
            <div class="gg-btn solid">立即听书</div>
          </div>
        </div>
        <div v-if="$$FormData.show_type === 'mode2'" class="book-content out ellipsis">{{ item.introduction }}</div>
      </div>
      <div v-if="!$$FormData.books.length" class="empty">
        请选择音频
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookAudiosPreview'
}
</script>

<style scoped lang="scss">
.books-preview {
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  margin-left: 10px;
}
.books-title {
  display: none;
  color: #3C4353;
  font-size: 16px;
  line-height: 23px;
  font-weight: 500;
  align-self: flex-start;
  padding-left: 10px;
  padding-right: 12px;
  & + .books-list {
    margin-top: 24px;
  }
}
.books-subtitle {
  display: none;
  opacity: 1;
  color: #979797;
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  align-self: flex-start;
  padding-left: 10px;
  padding-right: 12px;
  & + .books-list {
    margin-top: 24px;
  }
}
.books-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
}
.book-item {
  padding-left: 13px;
  padding-right: 12px;
  .book-item-inner {
    display: flex;
    gap: 13px;
    width: 100%;
    position: relative;
  }
  .cover-view {
    position: relative;
    width: 100px;
    height: 144px;
    flex-shrink: 0;
    overflow: hidden;
  }
  .book-cover {
    width: 100%;
    height: 100%;
  }
  .icon-listen-book {
    position: absolute;
    bottom: 3px;
    left: 3px;
    width: 24px;
    height: 24px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAYAAADj79JYAAAGUElEQVR4Xu2cr28kNxTHhxaXRcXFDVx8IKS4KFL/g4CWnpSgo01gUUNaVAWUVYl06KSAQ5Ui9dCFFKWoICpr9zMb7+2+9fyw/Z7Xntmv9JWirHfG/s7b73u2Z6ZpysQXS3615NdLfrvkd0u+eeEPS/74Qv52/3/90pbvLJrVMQ7owJfNSiiE3RQ0lRzr+2Z1bM4xayAAEUl0SqGsyAX4ppmR+J83q2jLKXIXEZ++fNZMEAhNNMtBl0AX9fSxepQstI/0tVrh+blqJsBcrM5qSEgleHQqGUPxyZXIkB2vnfh7ccD3phDVXWRSVYy3MyOcstiOePveLeZVs9uxqXPR7AlT9OuxZOxZMWexHbOJfhD7E81FXzS7J507yWMmIEPLkx24IpWaKqhBa5ym5yJlsWqdTuEvT3LgNhFdBUxt5cH3wqOjo59OT09/Ozs7+/38/Pwtfx8fH/8s2+2RyUl0b769FPKXi4uLtw8PD389Pj7+/V8Pnp+f/316evrn/v7+4/X19Xu+K4+XkdGzUZYns0/Zidrb29sPUtRQcKE4ljx+BkZbS9Z6m2gmSqVwqeCYRD12JM9pyGBryVaV8PO3EFqCc5ycnPwqz29EtAuqWrJsixHV+K8Upw/4OXaBX/N3yPdpe3V19U72w4hoOApcGflldd7c3PwhBZEgKhEIL+6zBD4jei8vL99xMeRxJDh33/EUOSrKTcvAMRaCaJR+8rtjyQUaEp5fR4ZqZjDKqUxMvbtPCG0RiOK7u7s/5XkcuPDyOwbsjXLTyqTPRqgkZHstYkvyfA70SbZXZm/FYhbdJEg5WECUpdjHWGIzXVZG32R7RXbW5WazSmzCV00ggKaFDLErf9A34354Z58myRIf7Rpkxrp4zb6LL9sq0ps8Teyky0oy1sM77OqTobXs2IqZnfiqkgyJapC+BE5fZTtFbtmKSXVCopKD4qebadIxSJ/VGdrcVrXCUwKyQTJ90W1Z/oXSZy2sVMp2SuTpjjXU/ZsoloMhWZUS3ZAE6uujUcWCxi14+Eh+mEzWNeRgSvBuSd/au2HybB/0Wng+SKZvSm0UOUnEs2U/6btsp8R2d98kYcptMeM6N4myLjesVtrEabL2LQfB+rVsUwplcidYZBslthMg9Vsg2EnfHAAo0b8dCQbZX9lGiW2lor5R7Ku/SaKyXSn0TYKMbr9oZ5zqgnPPiBxAjhXBWPoqKqMd/1Zw9RoccTMNQIU+wY1mnG0tLv+ZzIOl9HLnH8n0JU0SE6Lv4R4RL+kDfaFPsoQFsr0i9S0FygFswjB6RtMXFA6Gc4bWUtSTpm9RaBOlC84cwmh6r1+l8DOVA5AoXXAHg5XNVnCKcflBFH3Jx4daBAfKEzYmmTpT+75bESRqEhwobge2U/vkxStWAeXaSR9qExwwRnmMCLaLVywZyg+C6FtT7kONgivtBC2WTNuA8O3sDKFGwYFClK/fNBddi/umxUOoVfDEUnG9xQaiKxXf0uYQahU8cU2fjfo1ohOn71aDIdQqeOLGxNZtEtE3AoVUJw61Cs5Y5XECuHUjEIiaccpOjUGtggN5nJHc8m+HqAnQnCwlYVHL+96sKFuRG7BjUKvgCR6+YycOwbYydv1kE7UKHrmu4rUTh+Bqxbe7M4RaBY/cJtyqTiSiHhkM9fEaBY/0b6J78A2fwclzaMNBokbBI2eZ3mQpERXlvn3BLtQmeMKtb72PDG4iOMqPOx5Y8qEmwRMe/GrXvsci6uUG3MsxRvRaBE8QO/jlBiC4YoFjIr0GwRPEhr2VSR+C63JHtqW61llKFhyhIxOkI5oNViZdiJp9Orp3VHGDO0nVRX5JghMU9I0dHaX7HztnlWMRZS0z5agycAyirWVGbG+B0MLUX8ieyqiqZAjJu/sTZrJvd2GOL2gf4qIxxiGJfmJ0vR2Kg+gZxXaYs+jZxXZYNLudmTrNXtA+FmTo4IWuCklZrP5i9lhQg6o/YFsQEVu9ztaAyXuz9sy9+fVYYDFTmJUyBrMJjTZYniQyavR2+lx8VHcB3wvertsj6WuRXh0KBoG/lxrxkxFaoiSrwaPpyySF9oGElDvqEZloriYZWgEBiDaeEtC8AByLpzs49uxF7gMPHy2alVBEJJMqohNuXhD+dv9HWNryHWaE6weYSsL/p/iUjexS3PYAAAAASUVORK5CYII=");
    background-position: center center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .book-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }
  .book-name-text {
    color: #3C4353;
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
  }
  .author-name {
    margin-top: 3px;
    color: #3C4353;
    font-size: 12px;
    line-height: 25px;
    .dot {
      display: none;
    }
  }
  .book-content {
    color: #A6AAB8;
    font-size: 12px;
    line-height: 18px;
    -webkit-line-clamp: 4;
    &.out {
      display: none;
    }
  }
  .gg-btn {
    display: none;
  }
}
.books-preview.mode1,
.books-preview.mode2,
.books-preview.mode3 {
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  padding-top: 14px;
  padding-bottom: 24px;
  .books-title {
    display: block;
  }
  .books-subtitle {
    display: block;
  }
}
.books-preview.mode1,
.books-preview.mode2 {
  .books-list {
    align-items: center;
    gap: 24px;
  }
  .book-item-inner {
    .book-content {
      display: none;
    }
  }
  .book-item {
    width: 100%;
    padding-left: 10px;
    padding-right: 12px;
    gap: 16px;
    box-sizing: border-box;
    .cover-view {
      width: 89px;
      height: 128px;
    }
    .book-name-text {
      -webkit-line-clamp: 2;
      color: #3C4353;
      font-size: 14px;
      line-height: 22px;
      height: 43px;
      font-weight: 500;
      margin-top: 3px;
    }
    .author-name {
      color: #979797;
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      margin-top: 7px;
      .dot {
        display: inline-block;
      }
    }
    .gg-btn {
      display: flex;
      align-self: flex-end;
      width: 84px;
      height: 20px;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .book-content.out {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    margin-top: 8px;
    line-height: 20px;
  }
}
.books-preview.mode3 {
  .books-list {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 11px;
    padding-left: 10px;
    .book-item {
      padding: 0;
      &:last-child {
        margin-right: 10px;
      }
    }
    .book-item-inner {
      flex-direction: column;
      gap: 8px;
      .cover-view {
        width: 88px;
        height: 125px;
        .icon-listen-book {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 27px;
          background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFqADAAQAAAABAAAAEwAAAADUwbwqAAABZUlEQVQ4Ea2UgXGCMBiFSxcoIzCCI7BBR2g3KN3ADXQDrhP0nCAj1A3CBrpB+j1IIECCeue7e/zJe++PIUaLlxtwzpVEavgWRU9FUVyj+f1DFtxBA3MwGHVuxSJl0HBAb7zXUX/gBWqXO8+aKhzZ/fcw3HiyaAsFC+tcVJ7PUFyby/U6gUYpYGC5GcZUxmcpbp/M+9CFajVOhhIi2cr3UFy1iiDu5YCvlXlDoOez76SuohjGm3fvNixCn45EMEEbK6IVR+HBwbL/NerXTrto/pyh/0SK+3t0RfWoEcx7EYxUj+Rx4OkqNqkPRbcwYDhnZuHuBiO3sCWw5YV+1UZn/JHahTQCrbj0vX5Y6tH8Xc36UcQYd4VoRTXkxpFHZIJ2fJb5ZJy18Glj0SueuIS0bilGc/0b9q9pppeYviA0/aIqn7GMw7FIL6UL0mGAGVT/RNXt0H2c38XJb/F+Z02TZ/EMbIL/DxKK1WUmmO3mAAAAAElFTkSuQmCC");
          background-position: center center;
          background-size: 22px 19px;
          background-repeat: no-repeat;
          background-color: rgba(0,0,0,.3);
        }
      }
      .book-content,
      .author-name,
      .gg-btn {
        display: none;
      }
      .book-name-text {
        color: #3C4353;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        height: 43px;
      }
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  width: 100%;
  height: 75px;
}
</style>